import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";

export default function ConfigPage() {
  const [configs, setConfigs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  useEffect(() => {
    api.get("/api/v1/config").then(setConfigs).catch((e) => toast.error(e.message)).finally(() => setLoading(false));
  }, []);

  const handleUpdate = async (key: string, value: string) => {
    try {
      await api.put(`/api/v1/config/${key}`, { value });
      toast.success(`Updated ${key}`);
    } catch (e: any) {
      toast.error(e.message);
    }
  };

  const handleAdd = async () => {
    if (!newKey) return;
    try {
      await api.put(`/api/v1/config/${newKey}`, { value: newValue });
      setConfigs([...configs, { key: newKey, value: newValue, type: "text" }]);
      setNewKey("");
      setNewValue("");
      toast.success("Config added");
    } catch (e: any) {
      toast.error(e.message);
    }
  };

  const handleDelete = async (key: string) => {
    if (!confirm(`Delete config "${key}"?`)) return;
    try {
      await api.delete(`/api/v1/config/${key}`);
      setConfigs(configs.filter((c) => c.key !== key));
      toast.success("Deleted");
    } catch (e: any) {
      toast.error(e.message);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Configuration</h1>
      {loading ? (
        <div className="animate-pulse space-y-3">{[1, 2, 3].map((i) => <div key={i} className="h-12 bg-muted rounded-lg" />)}</div>
      ) : (
        <div className="space-y-3">
          {configs.map((c) => (
            <div key={c.key} className="bg-card rounded-xl border border-border p-4 flex items-center gap-3">
              <span className="text-sm font-medium text-muted-foreground w-40 shrink-0 truncate">{c.key}</span>
              <input defaultValue={c.value} onBlur={(e) => handleUpdate(c.key, e.target.value)} className="flex-1 px-3 py-1.5 rounded-lg border border-input bg-background text-sm" />
              <button onClick={() => handleDelete(c.key)} className="p-1.5 rounded hover:bg-destructive/10 text-muted-foreground hover:text-destructive"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          <div className="bg-card rounded-xl border border-dashed border-border p-4 flex items-center gap-3">
            <input value={newKey} onChange={(e) => setNewKey(e.target.value)} placeholder="Key" className="w-40 shrink-0 px-3 py-1.5 rounded-lg border border-input bg-background text-sm" />
            <input value={newValue} onChange={(e) => setNewValue(e.target.value)} placeholder="Value" className="flex-1 px-3 py-1.5 rounded-lg border border-input bg-background text-sm" />
            <button onClick={handleAdd} className="p-1.5 rounded-lg bg-primary text-primary-foreground hover:opacity-90"><Plus className="w-4 h-4" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
